import React, {PureComponent} from "react";
// import Hero from "../../../Components/Hero/Hero";
import Services from "../../../Components/Services/Services";
import {withRouter} from "react-router-dom";
import FeaturedRooms from "../../../Components/FeaturedRooms/FeaturedRooms";
import CarouselHome from "../../CarouselHome/CarouselHome";

class Home extends PureComponent{
   
    componentDidMount(){
        document.title = "Beach Resort | Home"
    }
    onHeroBtnClick(){ //redirects the user to "Rooms" page
        this.props.history.push("/rooms");
    }
    render(){
        return(
            <div>
                <CarouselHome onBtnClick={()=> this.onHeroBtnClick()}/>
                {/* <Hero onBtnClick={()=> this.onHeroBtnClick()} title="Luxurious Rooms" info="Deluxe Rooms Starting At $299" btnText="Our Rooms" Bcg="hero default-hero-bcg"/> */}
                <Services />
                <FeaturedRooms />
            </div>
        )
    }
}
export default withRouter(Home);